import $ from "jquery";
let React;

React = require("react");

class Base_Modal extends React.Component {
    closeModal(e) {
        e.preventDefault();
        return $(".react-modal").animate(
            {
                opacity: 0
            },
            100,
            (_this => () => {
                if (_this.props.onCloseModal) {
                    return _this.props.onCloseModal();
                }
            })(this)
        );
    }
    componentDidMount() {
        return $("body").css({
            overflow: "hidden"
        });
    }
    componentWillUnmount() {
        return $("body").css({
            overflow: ""
        });
    }
    render() {
        let className;
        className = ["react-modal", this.props.className, this.props.modalType];
        return (
            <div className={className.join(" ")}>
                {this.props.extraButton}
                <a
                    href="#"
                    onClick={this.closeModal.bind(this)}
                    title="Press ESC to close"
                    className="esc-page ui_close"
                />
                <div className="inner-modal container">
                    {this.props.modalContent}
                </div>
            </div>
        );
    }
}

export default Base_Modal;
